import type { ReactNode, } from "react";
import type { TabularRasaAccessorFnProps, TabularRasaAccessorFn } from "@bracket/ui/types";
import { style, Text, } from "@bracket/ui";
import { raise, } from "@bracket/errant";
import { Fit, } from "@bracket/ui/nodes";

export declare type CurrencyAccessorProps<K extends keyof T, T extends object> = TabularRasaAccessorFnProps<K, T, "TextNode"> &{
	value: unknown;
	accessorData?: Record<string, any>;
};

export const CurrencyAccessor = <K extends keyof T, T extends object>({ value, }: CurrencyAccessorProps<K, T> ): ReactNode => {

	try {

		return (
			<Fit $justify="flex-end" $debug>
				<Text font="numeric">
				{
					value === null || value === undefined ? " " :
					(
						typeof value === "number" ? value :
						typeof value === "string" ? parseFloat(value) :
						typeof value === "symbol" ? parseFloat(value.toString()) :
						raise("CurrencyAccessor - value must be a number")
					).toLocaleString("en-US", { style: "currency", currency: "USD", })
				}
				</Text>
			</Fit>
		);

	}
	catch(error) {

		console.error(error);
		return <Fit $justify="flex-end"><Text> </Text></Fit>;
	}

};
